import React from "react";
import { Box, TextField, Typography, InputAdornment } from "@mui/material";

type Props = {
  icon?: any;
  label?: string;
  placeholder?: string;
  value: string;
  type: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  readonly?: boolean;
  required?: boolean;
  name: string;
  multiline?: boolean;
  rows?: number;
  onClick?: any;
  error?: boolean;
  helperText?: any;
  showLabel?: boolean;
};

const InputField = ({
  icon,
  label,
  placeholder,
  value,
  type,
  onChange,
  readonly,
  name,
  multiline,
  rows,
  onClick,
  required,
  error,
  helperText,
  showLabel,
}: Props) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        // justifyContent: "start",
        alignItems: "start",
        gap: "6px",
        fontFamily: "SF Pro",
      }}
    >
      {showLabel && (
        <Typography
          sx={{
            color: "#49454F",
            fontSize: 15,
            fontFamily: "SF Pro",
            fontWeight: 500,
            lineHeight: "16px",
            ml: 1.5,
          }}
        >
          {label}
        </Typography>
      )}
      <TextField
        fullWidth
        // label={label}
        placeholder={placeholder}
        // variant="outlined"
        value={value}
        onChange={onChange}
        type={type}
        disabled={readonly}
        name={name}
        multiline={multiline}
        rows={rows}
        error={error}
        helperText={helperText}
        slotProps={{
          input: {
            startAdornment: icon && (
              <InputAdornment position="start">{icon}</InputAdornment>
            ),
            sx: {
              fontFamily: "SF Pro", // Applies font to input
            },
          },
        }}
        sx={{
          width: "100%",
          color: "#000000", // text color
          "&::placeholder": {
            color: "#888888", // NOT enough on its own
          },
          "& input::placeholder": {
            color: "#888888", // placeholder color for input
            opacity: 1,
          },
          "& textarea::placeholder": {
            color: "#888888", // for multiline
            opacity: 1,
          },
          "& .MuiOutlinedInput-root": {
            fontSize: "14px",
            fontWeight: "400",
            paddingX: "12px",
            backgroundColor: "#E5E4E2",
            borderRadius: multiline ? "16px" : "48px",
            "& fieldset": {
              borderWidth: "1px",
              borderColor: error ? "#D32F2F" : "transparent", // Red border when error
            },
          },
        }}
      />
      {required && (
        <Typography
          sx={{
            color: "#49454F",
            fontSize: 12,
            fontFamily: "SF Pro",
            fontWeight: 400,
            lineHeight: "16px",
            // mb: 1,
          }}
        >
          *required
        </Typography>
      )}
    </Box>
  );
};

export default InputField;
